import type {
    TContextStatuses,
    TErrorScreenStatuses,
    TStatuses,
} from '@alfa-bank/site-dc-form-api/src/models';

export const getStatus = (status?: TContextStatuses | TStatuses | TErrorScreenStatuses | null) => {
    switch (status) {
        case 'BAD_GATEWAY':
        case 'CLIENT_ERROR':
        case 'CONFLICT':
        case 'DT_CLIENT':
        case 'GONE':
        case 'INTERNAL_SERVER_ERROR':
        case 'NOT_FOUND':
        case 'NO_OFFER':
        case 'REFER_TO_OFFICE':
        case 'REJECT_COMPLETELY':
        case 'SESSION_EXPIRED':
        case 'TOO_MANY_REQUESTS':
        case 'UNAUTHORIZED':
        case 'VALIDATION_ERROR':
            return status;
        default:
            return 'INTERNAL_SERVER_ERROR';
    }
};
